import { Helmet } from 'react-helmet-async';
import customercapture0 from "../feature/customercapture0.webp";
import poslite from "../feature/poslite.webp";
import linkinbio from "../feature/linkinbio.webp";
import ordertracking from "../feature/ordertracking.jpg";

import FeatureSection from './FeatureSection';
import FeaturesBottom from './FeaturesBottom';
import FeatureHeroSection from './FeatureHeroSection';
import main from "../feature/capture.webp";
import ContactIcon from './ContactIcon';

function CaptureData(){

    return (
        <>
            <Helmet>
                <title>Kadhr — Sales & Customer Capture</title>
                <meta
                    name="description"
                    content="Capture every sale across online, in-store, and chat — while automatically building a powerful customer database with every transaction."
                />
            </Helmet>

            <main className="mtopcon0 ovrflwhdn" id="up">
                <ContactIcon/>
                <div className="row">
                    <FeatureHeroSection
                        title="Capture every sale. Build customer history automatically"
                        description="Whether you sell online, in-store, or through chat — Kadhr records every order and turns it into usable customer data."
                        image={main}
                    />
                    <div className="col-12 text-center mt-5 pt-6indx0" id='features'>
                        <FeatureSection title="Simple POS" description="Sell from your phone or laptop — no expensive hardware needed." image={poslite} reverse />
                        <FeatureSection title="Link-in-Bio Store" description="Turn your Instagram or WhatsApp into a checkout-ready store." image={linkinbio} />
                        <FeatureSection title="Order Tracking" description="Track every order — from customer to payment to delivery." image={ordertracking} reverse />
                        <FeatureSection title="Automatic Customer Capture" description="Every sale builds your customer database — without extra steps." image={customercapture0} />
                    </div>                 

                    <FeaturesBottom/>

                </div>
            </main>
        </>
    );
}

export default CaptureData;
